export const AnalyticsRoutes = { path: 'analytics/*', lazy: () => import('../pages/analytics') };
